import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
.theme-clr {
    color: var(--app-color-dark);
}
button, a {
    cursor: pointer;
}
.uppercase {
    text-transform: uppercase;
}
.d-flex {
    display: flex;
}
.d-block {
    display: block;
}
`;

export default GlobalStyle;
